export default __webpack_public_path__ + "ui/assets/img/sim-card-20.svg";